import React, { Component } from 'react';
import { CloseIcon, UploadIcon } from '../shared/icons';
import styles from './index.module.scss';

class UploadBLModal extends Component {
  constructor(props) {
    super(props);
    this.state = { dragOver: false, file: null, bookingId: '' };
    this.fileRef = React.createRef();
  }

  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) this.setState({ file, dragOver: false });
  };

  handleFile = (e) => {
    const file = e.target.files[0];
    if (file) this.setState({ file });
  };

  handleSubmit = () => {
    const { onUpload } = this.props;
    if (!this.state.bookingId.trim()) return;
    if (onUpload) onUpload(this.state.bookingId, this.state.file);
  };

  render() {
    const { rfq, doc, onClose, submitting } = this.props;
    const { dragOver, file, bookingId } = this.state;

    return (
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal} onClick={e => e.stopPropagation()}>
          <div className={styles.header}>
            <span className={styles.title}>Upload BL</span>
            <button className={styles.closeBtn} onClick={onClose}><CloseIcon /></button>
          </div>
          <div className={styles.subtitle}>
            {doc && <><span>Doc: {doc.name}</span> &nbsp;·&nbsp; </>}
            RFQ {rfq.rfqNumber}
          </div>

          <div className={styles.fieldLabel}>BL Number</div>
          <input
            className={styles.textInput}
            type="text"
            placeholder="Enter BL Number"
            value={bookingId}
            onChange={e => this.setState({ bookingId: e.target.value })}
          />

          <div
            className={`${styles.dropZone} ${dragOver ? styles.dragOver : ''}`}
            onDragOver={e => { e.preventDefault(); this.setState({ dragOver: true }); }}
            onDragLeave={() => this.setState({ dragOver: false })}
            onDrop={this.handleDrop}
            onClick={() => this.fileRef.current.click()}
          >
            <input ref={this.fileRef} type="file" accept=".pdf,.png,.jpg,.jpeg" style={{ display: 'none' }} onChange={this.handleFile} />
            <div className={styles.dropIconCircle}><UploadIcon size={22} /></div>
            <div className={styles.dropMain}>Drop file here or click to browse</div>
            <div className={styles.dropSub}>PDF, PNG, JPG up to 10MB</div>
            {file && <div className={styles.fileName}>{file.name}</div>}
          </div>

          <div className={styles.footer}>
            <button className={styles.cancelBtn} onClick={onClose}>Cancel</button>
            <button className={styles.uploadBtn} onClick={this.handleSubmit} disabled={submitting || !bookingId.trim()}>
              <UploadIcon size={14} /> {submitting ? 'Uploading...' : 'Upload BL'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadBLModal;
